import { render, staticRenderFns } from "./kiwiirccom.vue?vue&type=template&id=212f7c3c&"
import script from "./kiwiirccom.vue?vue&type=script&lang=js&"
export * from "./kiwiirccom.vue?vue&type=script&lang=js&"
import style0 from "./kiwiirccom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports